module.exports = __webpack_public_path__ + "02_short_grey.d50a9c45.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/02_short_grey.png
// module id = E2mh
// module chunks = 0